import { Link } from "react-router";
import ProgressBar from "../progressBar/progressBar";
import styles from "./ProjectCard.module.css";

export default function ProjectCard(props) {
    return (
        <>
            <Link to={props.link} style={{ textDecoration: "none", fontSize: "13px" }}>
                <div className={styles.PCard}>
                    <div className="card mt-3 pt-2 pb-3 shadow" >
                        <ul style={{ listStyle: "none" }}>
                            <li className={`${styles.date} pb-2`}>{props.date}</li>

                            <div className="row">
                                <div className="col-8 col-sm-8 col-md-8 col-lg-7">
                                    <li className={`${styles.title} pb-1`}>{props.title}</li>
                                </div>
                                <div className="col-4 col-sm-4 col-md-4 col-lg-5 text-end  pe-5">
                                    <Link to={props.link} style={{ textDecoration: "none", fontSize: "12px" }}>
                                        View Details
                                    </Link>
                                </div>
                            </div>

                            <li className={`${styles.team} ps-3 pe-3 pt-1 pb-1 w-auto d-inline-block`}>{props.team}</li>
                            <li className={`${styles.description} pb-0 pe-5`}>{props.description}</li>
                        </ul>

                        <div className="ps-4 pe-4">
                            <div className="d-flex justify-content-between">
                                <p className={styles.progressTitle}>Completion</p>
                                <p className={styles.progressPercentage}>{props.percentage}%</p>
                            </div>
                            <ProgressBar percent={props.percentage} />
                        </div>
                    </div>
                </div>
            </Link>

        </>
    );
}
